import askGithub from './../lib/askGithub'
import ERROR_CODES from './../lib/errorCodes'
import getBranchAndRepositoryDetails from './../lib/getBranchAndRepositoryDetails'

/**
 * Get a file from Github
 * @param {string} authToken
 * @param {string} repoId
 * @param {string} path
 * @param {string} branch
 * @returns {Promise<string>}
 */
var getFile = async function(authToken, branchId, path){

  var {
    repositoryId: repoId,
    branchName
  } = await getBranchAndRepositoryDetails(authToken, branchId)


  var result = await askGithub(authToken, `query {
    node(id:"${repoId}") {
      ... on Repository {
        object(expression: "${branchName}:${path}") {
          ... on Blob {
            text,
            id
          }
        }
      }
    }
  }`)

  var file = result['data']['node']['object']
  if (!file){
    var error = new Error('File not found in repository')
    error.code = ERROR_CODES.GRAPHQL_FILE_NOT_FOUND
    throw error
  }
  return {
    // We make the id unique across branches and unique each time, this way
    // we can copy files to different branches without worrying about collisions
    id: generateId(),
    text: file['text'],
    path,
  }
}

export default getFile


/**
 * Generate a random id
 * @returns {string}
 */
function generateId(){
  return btoa(Math.random()).substring(0,12)
}

/**
 * By default the file ids are not unique across branches. This function makes
 * them unique across branches.
 * @param {string} fileId
 * @param {string} branchId
 */
/*export function encodeBranchIntoId(fileId, branchId){
  return branchId + fileId
}*/


/**
 * By default the file ids are not unique across branches. This function makes
 * them unique across branches. Work working with the server you must call
 * the counter part decodeBranchFromId() to get the real file id.
 * @param {string} fileId
 * @param {string} branchId
 *//*
export function decodeBranchFromId(fileId, branchId){
  return fileId.slice(branchId.length)
}*/


// WEBPACK FOOTER //
// ./src/data/getFile.js